import React, { useEffect, useRef } from 'react';
import styles from '../css/comuns/InfinitePossibilities.module.css';
import { config } from '../../data';

const InfinitePossibilities = () => {
  const logosCustomRef = useRef(null);

  useEffect(() => {
    if (logosCustomRef.current) {
      const images = logosCustomRef.current.querySelectorAll('img');
      let delay = 0;

      images.forEach(img => {
        img.style.transitionDelay = `${delay}s`;
        img.classList.add(styles.show);
        delay += 0;
      });
    }
  }, []);

  return (
    <div className={styles['container-custom']}>
      <div className="row">
        <div className="col-12">
          <h1 className="mb-4">
            {config.texts.infinitePossibilities.titulo}
          </h1>
          <div className={styles['line-custom']}></div>
          <div className={`${styles['logos-custom']} mt-4`} ref={logosCustomRef}>
            {config.images.infinitePossibilities.logos.map((logo, index) => (
              <img 
                key={index} 
                src={logo} 
                alt={config.images.infinitePossibilities.alt[index]} 
                className="img-fluid" 
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfinitePossibilities;